"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractionsState = void 0;
/**
 * We need to bound child logger, as an example full-screen-modal logger, with parent,
 * desktop, logger, so we taking original component id for creation of namespace
 */
var INTERACTIONS_STATE = 'interactions-state';
var REQUEST_INTERACTIONS_STATE = "get-".concat(INTERACTIONS_STATE);
var PUBLISH_INTERACTIONS_STATE = "publish-".concat(INTERACTIONS_STATE);
var InteractionsState = /** @class */ (function () {
    function InteractionsState(_a) {
        var _this = this;
        var compId = _a.compId, pubSub = _a.pubSub;
        this.promise = Promise.resolve();
        this.state = {};
        this.saveInteractions = function (_a) {
            var data = _a.data;
            _this.state = data;
        };
        this.publishInteractions = function () {
            _this.pubSub.publish(_this.publishInteractionsAction, _this.state);
            _this.state = {};
        };
        this.requestInteractions = function () {
            _this.promise = new Promise(function (resolve) {
                _this.pubSub.subscribe(_this.publishInteractionsAction, function (event) {
                    _this.saveInteractions(event);
                    resolve();
                });
            });
            _this.pubSub.publish(_this.requestInteractionsAction);
        };
        this.subscribeOnInteractionsRequest = function () {
            _this.pubSub.subscribe(_this.requestInteractionsAction, _this.publishInteractions);
        };
        this.pubSub = pubSub;
        this.state = {};
        this.promise = Promise.resolve();
        this.publishInteractionsAction = "[".concat(compId, "] ").concat(PUBLISH_INTERACTIONS_STATE);
        this.requestInteractionsAction = "[".concat(compId, "] ").concat(REQUEST_INTERACTIONS_STATE);
    }
    InteractionsState.prototype.fetch = function () {
        return this.promise;
    };
    InteractionsState.prototype.has = function (interaction) {
        return this.state[interaction];
    };
    InteractionsState.prototype.start = function (interaction) {
        this.state[interaction] = true;
    };
    InteractionsState.prototype.complete = function (interaction) {
        this.state[interaction] = false;
    };
    return InteractionsState;
}());
exports.InteractionsState = InteractionsState;
//# sourceMappingURL=interactions-state.js.map